import {
    ElContainer, ElHeader, ElAside, ElMain, ElFooter,
    ElMessage, ElMessageBox, ElRow, ElCol, ElSubMenu,
    ElMenu, ElMenuItem, ElTabs, ElTabPane, ElSwitch,
    ElMenuItemGroup, ElAffix, ElDropdown, ElDropdownMenu, ElDropdownItem,
    ElTable, ElButton, ElLoading, ElTableColumn, ElProgress,
    ElPagination, ElConfigProvider, ElCheckboxGroup, ElCheckbox,
    ElInput, ElSelect, ElOption, ElDatePicker, ElForm,
    ElFormItem, ElRadio, ElRadioGroup, ElCheckTag, ElTag,
    ElBreadcrumb, ElBreadcrumbItem, ElEmpty, ElDialog, ElPopover,
    ElCheckboxButton, ElAvatar, ElCascader,ElTooltip, ElTree, ElInputNumber,
    ElRadioButton, ElCard, ElImage, ElUpload, ElTreeSelect, ElSteps, ElStep,
    ElTimePicker,ElDescriptions,ElDescriptionsItem,ElRate,ElPageHeader,ElBadge,
    ElIcon, ElStatistic, ElCollapse, ElCollapseItem, ElDrawer,ElPopconfirm, ElCalendar,
    ElResult,ElOptionGroup
} from "element-plus";


const components = [
    ElContainer, ElHeader, ElAside, ElMain, ElFooter,
    ElMessage, ElMessageBox, ElRow, ElCol, ElSubMenu,
    ElMenu, ElMenuItem, ElTabs, ElTabPane, ElSwitch,
    ElMenuItemGroup, ElAffix, ElDropdown, ElDropdownMenu, ElDropdownItem,
    ElTable, ElButton, ElLoading, ElTableColumn, ElProgress,
    ElPagination, ElConfigProvider, ElCheckboxGroup, ElCheckbox,
    ElInput, ElSelect, ElOption, ElDatePicker, ElForm,
    ElFormItem, ElRadio, ElRadioGroup, ElCheckTag, ElTag,
    ElBreadcrumb, ElBreadcrumbItem, ElEmpty, ElDialog, ElPopover,
    ElCheckboxButton, ElAvatar, ElCascader, ElTooltip, ElTree, ElInputNumber,
    ElRadioButton, ElCard, ElImage, ElUpload, ElTreeSelect, ElSteps, ElStep,
    ElTimePicker,ElDescriptions,ElDescriptionsItem,ElRate,ElPageHeader,ElBadge,
    ElIcon, ElStatistic, ElCollapse, ElCollapseItem, ElDrawer,ElPopconfirm, ElCalendar,
    ElResult,ElOptionGroup
]

const plugins = [
    ElLoading, ElMessage, ElMessageBox
]

const installElement = (app) => {
    components.forEach((component) => {
        app.component(component.name, component)
    })

    plugins.forEach((plugin) => {
        app.use(plugin)
    })

    //注入快捷操作
    app.provide('message', ElMessage);
    app.provide('confirm', ElMessageBox.confirm);
    app.provide('alert', ElMessageBox.alert);
}

export default installElement
